import { render, staticRenderFns } from "./HeatStrokeIndexMap.vue?vue&type=template&id=32665c0a&"
import script from "./HeatStrokeIndexMap.vue?vue&type=script&lang=js&"
export * from "./HeatStrokeIndexMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports